import React from "react";

const SoundWave = ({ size, color, opacity, style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      style={{ ...style }}
    >
      <g opacity={opacity ? opacity : "0.4"}>
        <path
          d="M10.6673 5.33301V26.6663M5.33398 13.333V18.6663M16.0007 10.6663V21.333M21.334 7.99967V23.9997M26.6673 13.333V18.6663"
          stroke={color ? color : "black"}
          //   style="stroke:black;stroke:black;stroke-opacity:1;"
          stroke-width="3"
          stroke-linecap="square"
        />
      </g>
    </svg>
  );
};

export default SoundWave;
